import React from 'react';
import PropTypes from 'prop-types';
import cn from 'classnames';

import { Text } from '../Elements';

import classes from './HealthStatus.module.scss';

const HealthStatus = ({ status }) => {
  const dataColor = () => {
    switch (status) {
      case 'Champion':
        return 'green';
      case 'Healthy':
        return 'lgreen';
      case 'Need Attention':
        return 'yellow';
      case 'At Risk':
        return 'red';
      default:
        return status;
    }
  };

  return (
    <Text className={cn(classes[dataColor(status)], classes.border)} size={2}>
      {status}
    </Text>
  );
};

HealthStatus.propTypes = {
  status: PropTypes.string
};

export default HealthStatus;
